const getters = {
  // sidebar: (state) => state.app.sidebar,
  userInfo: (state) => state.user.userInfo,
  userId: (state) => state.user.userInfo.id,
  token: state => state.user.token,
  name: state => state.user.name,
  permissions: state => state.user.permissions,
  authority: state => state.user.authority,
  menuCodes: state => state.user.menuCode,
  showMenu: state => state.user.showMenu,
  HSParams: state => state.homeStation.params,
  SugBParams: state => state.suggestBull.params,
  MenuCode: state => state.topBar.MenuCode,
  addRoutes: state => state.topBar.addRoutes,
  UID: state => state.meeting_user.UID,
  departmentName: state => state.userInfo.departmentName,
  nickname: state => state.meeting_user.nickname,
  meetingState: state => state.state.meetingState,
  memberList: state => state.state.memberList
}
export default getters
